// ThemeSwitcher.js
// Floating theme switcher for quick access
import React from 'react';

const ThemeSwitcher = ({ theme, setTheme }) => (
  <div style={{
    position: 'fixed',
    bottom: 80,
    right: 32,
    zIndex: 1200,
    background: '#232323',
    borderRadius: 16,
    boxShadow: '0 2px 16px #0005',
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'center',
  }}>
    <span style={{ color: '#b3b3b3', fontSize: 13, marginBottom: 4 }}>Theme</span>
    <button onClick={() => setTheme('vs-dark')} style={{ background: theme==='vs-dark' ? '#6366f1' : '#232323', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', cursor: 'pointer' }}>Dark</button>
    <button onClick={() => setTheme('vs-light')} style={{ background: theme==='vs-light' ? '#6366f1' : '#232323', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', cursor: 'pointer' }}>Light</button>
    <button onClick={() => setTheme('hc-black')} style={{ background: theme==='hc-black' ? '#6366f1' : '#232323', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', cursor: 'pointer' }}>High Contrast</button>
  </div>
);

export default ThemeSwitcher;
